/**
 * get history at particular version in history format. we will need it anyway.
 * current anamnesisdto can come from backend, we already have it there.
 * compare anamnesisdto with history and return diff in history format.
 *
 */

import _ from "lodash";
import { addComplexDiffToResults } from "./ComplexDiffManager";
import { addPrimitiveDiffToResults } from "./PrimitiveDiffManager";
import { versionNow } from "./HistoryUtils";

/**
 * Map<String, List<{
 *      {
 *             id
 *             patientId
 *             mainCategory
 *             question
 *             answer
 *             version
 *             modificationDate
 *             role
 *             userId
 *      } anamnesisQuestion
 *      Map<String, {
 *              id
 *              anamnesisQuestionId
 *              question
 *              answer
 *              patientId
 *      }> anamnesisSubData
 * }>>
 * we expect version to be lexicographically sortable zero padded YYYY-WW: 2023-03
 * we expect history to be already sorted by anamnesisQuestion.version
 */
function getLatestHistoryEntriesAtVersion(history, version) {
    //filter gives out shallow copies and you dont want to end up mutating the original history.
    const clone = _.cloneDeep(history);
    Object.keys(clone).forEach((key) => {
        clone[key] = clone[key].filter(
            (question) =>
                !question.version ||
                (question.version <= version && (!question.deletedAtVersion || question.deletedAtVersion > version)),
        );
    });
    return clone;
}

function getLatestHistory(history) {
    const clone = _.cloneDeep(getLatestHistoryEntriesAtVersion(history, versionNow()));
    const primitiveHistory = {};
    const complexHistory = {};
    Object.keys(clone).forEach((key) => {
        if (clone[key] && clone[key]?.[0] && clone[key]?.[0]?.anamnesisQuestion?.answer !== "SUB_DATA") {
            primitiveHistory[key] = [clone[key][0]];
        } else {
            complexHistory[key] = clone[key];
        }
    });

    return {
        primitiveHistory,
        complexHistory,
    };
}

/**
 * @param anamnesisDto
 * @param history
 * @param supplementalQuestionData { patientId, role, userId }
 * @returns {{}}
 */
export function getDiff(anamnesisDto, history, supplementalQuestionData) {
    const result = {};
    const { primitiveHistory, complexHistory } = getLatestHistory(history);
    const { patientId, ...otherAnamnesisDtoData } = anamnesisDto;
    Object.keys(otherAnamnesisDtoData).forEach((key) => {
        const anamnesisDtoValue = anamnesisDto[key];
        const isEmpty = anamnesisDtoValue === null || anamnesisDtoValue === undefined;
        const isComplex = !isEmpty && anamnesisDtoValue instanceof Array;
        const isPrimitive = !isEmpty && !(anamnesisDtoValue instanceof Array);

        if (isComplex) {
            addComplexDiffToResults(key, anamnesisDtoValue, complexHistory, result, supplementalQuestionData);
        } else if (isPrimitive) {
            addPrimitiveDiffToResults(key, anamnesisDtoValue, primitiveHistory, result, supplementalQuestionData);
        }
    });
    return result;
}
